export enum ETeam {
  hyperTeam = 'hyperTeam',
  team = 'team',
  taggerTeam = 'taggerTeam',
}
